/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_ListInputs */

const en_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New List`)
};

const fr_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une nouvelle liste`)
};

const de_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Liste erstellen`)
};

const it_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea nuovo elenco`)
};

const ru_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый список`)
};

const es_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva lista`)
};

const zh_cn2_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新列表`)
};

const ja_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいリストを作成`)
};

const hi_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई सूची बनाएँ`)
};

const pt_pt2_create_new_list = /** @type {(inputs: Create_New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar nova lista`)
};

/**
* | output |
* | --- |
* | "Create New List" |
*
* @param {Create_New_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_new_list = /** @type {((inputs?: Create_New_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_create_new_list(inputs)
	if (locale === "de") return de_create_new_list(inputs)
	if (locale === "it") return it_create_new_list(inputs)
	if (locale === "ru") return ru_create_new_list(inputs)
	if (locale === "es") return es_create_new_list(inputs)
	if (locale === "zh-CN") return zh_cn2_create_new_list(inputs)
	if (locale === "ja") return ja_create_new_list(inputs)
	if (locale === "hi") return hi_create_new_list(inputs)
	if (locale === "pt-PT") return pt_pt2_create_new_list(inputs)
	return en_create_new_list(inputs)
});